<script setup>
import { ToastHost } from '@drama/ui'
</script>

<template>
  <RouterView />
  <ToastHost />
</template>
